import { Component, OnInit } from '@angular/core';
import { UrlsService } from '../../Services/urls.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
    imports: [],
    providers: [],
    styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent implements OnInit {

  url: any;
  constructor( private router: Router) { }

  ngOnInit() {
  }

  backToRoute()
  {
   // this.url="/pages"+this.urlService.BackUrl;
    this.url="/pages/MainDashboard";
    this.router.navigate([this.url]);
    ;
  }
}
